<section class="app-dialog pruebas-dialogo registrar-ejecucion" [attr.aria-busy]="guardando">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <div>
        <p class="app-dialog__eyebrow">Gestión de Proyectos</p>
        <h2 [id]="idTitulo">{{ titulo }}</h2>
        <p *ngIf="subtitulo">{{ subtitulo }}</p>
        <p class="registrar-ejecucion__registro" *ngIf="lineaRegistro">
          <span class="material-icons" aria-hidden="true">history</span>{{ lineaRegistro }}
        </p>
      </div>
    </div>
    <button type="button" class="app-dialog__close app-dialog__close--icono" aria-label="Cerrar" title="Cerrar"
            [disabled]="guardando" (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content pruebas-dialogo__contenido">
    <output class="pruebas-dialogo__aviso" *ngIf="!datos.puedeRegistrarPruebas">
      <strong>No puedes registrar pruebas en esta etapa.</strong> {{ sinPermiso }}
    </output>

    <form class="registrar-ejecucion__formulario" [formGroup]="formulario" autocomplete="off">
      <!-- 1. Qué se probó -->
      <section class="pruebas-dialogo__seccion" aria-labelledby="t2-s-que">
        <h3 id="t2-s-que" class="pruebas-dialogo__titulo">Qué se probó</h3>

        <ng-container *ngIf="esEdicion; else queSeProboAlta">
          <dl class="pruebas-dialogo__fijos">
            <div class="pruebas-dialogo__fijo"><dt>Versión</dt><dd>{{ etiquetaVersionElegida }}</dd></div>
            <div class="pruebas-dialogo__fijo"><dt>Ambiente</dt><dd>{{ ambiente }}</dd></div>
            <div class="pruebas-dialogo__fijo"><dt>Tipo de prueba</dt><dd>{{ tipoGuardado }}</dd></div>
            <div class="pruebas-dialogo__fijo"><dt>Ciclo</dt><dd>{{ datos.ejecucion?.ciclo ?? "—" }}</dd></div>
          </dl>
          <p class="pruebas-dialogo__ayuda">
            La versión, el tipo y el ciclo no cambian al editar; para cambiarlos, registra otra ejecución. El ambiente se hereda de la versión.
          </p>
        </ng-container>

        <ng-template #queSeProboAlta>
          <div class="registrar-ejecucion__rejilla">
            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Versión</mat-label>
              <mat-select formControlName="idVersion" required>
                <mat-option *ngFor="let opcion of opcionesVersion" [value]="opcion.id">{{ opcion.etiqueta }}</mat-option>
              </mat-select>
              <mat-hint>Se puede probar cualquier versión, incluidas las cerradas.</mat-hint>
              <mat-error>{{ errorDe("idVersion") }}</mat-error>
            </mat-form-field>

            <dl class="pruebas-dialogo__fijos">
              <div class="pruebas-dialogo__fijo">
                <dt>Ambiente</dt>
                <dd>{{ ambiente }}</dd>
                <dd class="pruebas-dialogo__ayuda">Heredado de la versión</dd>
              </div>
            </dl>

            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Tipo de prueba</mat-label>
              <mat-select formControlName="tipo" required>
                <mat-option *ngFor="let tipo of tipos" [value]="tipo.clave">{{ tipo.nombre }}</mat-option>
              </mat-select>
              <mat-hint *ngIf="textoCiclo">{{ textoCiclo }}</mat-hint>
              <mat-error>{{ errorDe("tipo") }}</mat-error>
            </mat-form-field>
          </div>
        </ng-template>

        <div class="registrar-ejecucion__rejilla">
          <!-- mat-label es la etiqueta que se ve; la <label for> oculta es la que leen los lectores de pantalla. -->
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label aria-hidden="true">Fecha de ejecución</mat-label>
            <label class="cdk-visually-hidden" for="t2-fecha">Fecha de ejecución</label>
            <input matInput id="t2-fecha" formControlName="fecha" required placeholder="dd/mm/aaaa" [matDatepicker]="calendario"
                   [min]="fechaMinima" [max]="hoy" />
            <mat-datepicker-toggle matIconSuffix [for]="calendario" aria-label="Abrir calendario"></mat-datepicker-toggle>
            <mat-datepicker #calendario></mat-datepicker>
            <mat-hint>{{ textoFechas }}</mat-hint>
            <mat-error>{{ errorDe("fecha") }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Ejecutó</mat-label>
            <mat-select formControlName="idEmpleadoEjecuto" required>
              <mat-option *ngFor="let ejecutor of ejecutores" [value]="ejecutor.idEmpleado">
                {{ ejecutor.nombre || "Sin nombre" }}<span class="registrar-ejecucion__rol" *ngIf="ejecutor.rol"> · {{ ejecutor.rol }}</span>
              </mat-option>
            </mat-select>
            <mat-hint *ngIf="!ejecutores.length">La etapa no tiene líderes ni recursos asignados.</mat-hint>
            <mat-error>{{ errorDe("idEmpleadoEjecuto") }}</mat-error>
          </mat-form-field>
        </div>
      </section>

      <!-- 2. Resultado -->
      <section class="pruebas-dialogo__seccion" aria-labelledby="t2-s-resultado">
        <h3 id="t2-s-resultado" class="pruebas-dialogo__titulo">Resultado</h3>
        <fieldset class="registrar-ejecucion__resultados" [attr.aria-describedby]="errorVisible('resultado') ? 't2-error-resultado' : null">
          <legend>Resultado de la ejecución *</legend>
          <div class="registrar-ejecucion__opciones">
            <span *ngFor="let opcion of resultados" class="registrar-ejecucion__opcion">
              <input type="radio" class="cdk-visually-hidden" formControlName="resultado" name="resultado" [id]="'t2-res-' + opcion.clave"
                     [value]="opcion.clave" />
              <label [for]="'t2-res-' + opcion.clave" [class.is-on]="formulario.controls.resultado.value === opcion.clave">
                <span class="table-page__status-badge app-chip-icono registrar-ejecucion__chip" [ngClass]="opcion.clase">
                  <span class="material-icons" aria-hidden="true">{{ opcion.icono }}</span>{{ opcion.nombre }}
                </span>
                <span class="registrar-ejecucion__descripcion">{{ opcion.descripcion }}</span>
              </label>
            </span>
          </div>
        </fieldset>
        <p id="t2-error-resultado" class="pruebas-dialogo__error" *ngIf="errorVisible('resultado') as error">{{ error }}</p>

        <div class="registrar-ejecucion__casos">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label aria-hidden="true">Casos ejecutados</mat-label>
            <label class="cdk-visually-hidden" for="t2-casos">Casos ejecutados</label>
            <input matInput id="t2-casos" type="number" min="1" step="1" inputmode="numeric" formControlName="casosEjecutados" required
                   aria-describedby="t2-error-casos" />
            <mat-error>{{ errorDe("casosEjecutados") }}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label aria-hidden="true">Aprobados</mat-label>
            <label class="cdk-visually-hidden" for="t2-aprobados">Aprobados</label>
            <input matInput id="t2-aprobados" type="number" min="0" step="1" inputmode="numeric" formControlName="casosAprobados" required
                   aria-describedby="t2-error-casos" />
            <mat-error>{{ errorDe("casosAprobados") }}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label aria-hidden="true">Fallidos</mat-label>
            <label class="cdk-visually-hidden" for="t2-fallidos">Fallidos</label>
            <input matInput id="t2-fallidos" type="number" min="0" step="1" inputmode="numeric" formControlName="casosFallidos" required
                   aria-describedby="t2-error-casos" />
            <mat-error>{{ errorDe("casosFallidos") }}</mat-error>
          </mat-form-field>
        </div>
        <p id="t2-error-casos" class="pruebas-dialogo__error" aria-live="polite">{{ errorCasos }}</p>
      </section>

      <!-- 3. Incidencias levantadas -->
      <section class="pruebas-dialogo__seccion" aria-labelledby="t2-s-incidencias">
        <div class="pruebas-dialogo__cabeza">
          <h3 id="t2-s-incidencias" class="pruebas-dialogo__titulo">Incidencias levantadas</h3>
          <span class="pruebas-dialogo__contador">{{ vinculadas.length }} {{ vinculadas.length === 1 ? "vinculada" : "vinculadas" }}</span>
        </div>
        <ul class="registrar-ejecucion__incidencias" *ngIf="vinculadas.length; else sinIncidencias">
          <li *ngFor="let incidencia of vinculadas; trackBy: trackVinculada">
            <strong class="registrar-ejecucion__folio">{{ incidencia.folio === null ? "Sin folio" : "#" + incidencia.folio }}</strong>
            <span class="registrar-ejecucion__titulo-inc" [attr.title]="incidencia.titulo">{{ incidencia.titulo ?? "Incidencia " + incidencia.id }}</span>
            <span class="app-prioridad" [ngClass]="clasePrioridad(incidencia.prioridad)" *ngIf="incidencia.prioridad">
              <span class="cdk-visually-hidden">Prioridad</span>{{ nombrePrioridad(incidencia.prioridad) }}
            </span>
            <button type="button" class="table-page__action-btn" title="Quitar" [disabled]="!editable"
                    [attr.aria-label]="'Quitar ' + (incidencia.folio === null ? 'la incidencia' : '#' + incidencia.folio) + ' ' + (incidencia.titulo ?? '')"
                    (click)="quitarIncidencia(incidencia)">
              <span class="material-icons" aria-hidden="true">close</span>
            </button>
          </li>
        </ul>
        <ng-template #sinIncidencias>
          <p class="pruebas-dialogo__ayuda">Ninguna incidencia ligada a esta ejecución.</p>
        </ng-template>
        <div class="registrar-ejecucion__botones">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" [disabled]="!editable"
                  (click)="vincularExistente()">
            <span class="material-icons" aria-hidden="true">link</span>
            <span>Vincular incidencia existente</span>
          </button>
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  [disabled]="!editable || !formulario.controls.idVersion.value" (click)="crearIncidencia()">
            <span class="material-icons" aria-hidden="true">add_circle_outline</span>
            <span>Crear incidencia</span>
          </button>
        </div>
        <p class="pruebas-dialogo__ayuda" *ngIf="esEdicion">Quitar una incidencia solo la desvincula de esta ejecución.</p>
      </section>

      <!-- 4. Evidencia y observaciones -->
      <section class="pruebas-dialogo__seccion" aria-labelledby="t2-s-evidencia">
        <div class="pruebas-dialogo__cabeza">
          <h3 id="t2-s-evidencia" class="pruebas-dialogo__titulo">Evidencia</h3>
          <span class="pruebas-dialogo__contador">{{ totalEvidencias }} de {{ maximoEvidencias }} archivos</span>
        </div>

        <ul class="pruebas-dialogo__archivos" *ngIf="guardadas.length" aria-label="Evidencia cargada">
          <li *ngFor="let guardada of guardadas" [class.is-quitada]="guardada.quitar">
            <span class="pruebas-dialogo__archivo">
              <button type="button" class="registrar-ejecucion__ver" [attr.title]="'Ver ' + guardada.nombre" (click)="verEvidencia(guardada)">
                {{ guardada.nombre }}
              </button>
              <span>{{ guardada.quitar ? "Se quitará al guardar" : guardada.linea }}</span>
            </span>
            <button type="button" class="table-page__action-btn" [disabled]="!editable"
                    [attr.title]="guardada.quitar ? 'Dejar' : 'Quitar'"
                    [attr.aria-label]="(guardada.quitar ? 'Dejar ' : 'Quitar ') + guardada.nombre" (click)="alternarGuardada(guardada)">
              <span class="material-icons" aria-hidden="true">{{ guardada.quitar ? "undo" : "close" }}</span>
            </button>
          </li>
        </ul>

        <input #entrada id="t2-evidencia" type="file" class="cdk-visually-hidden" multiple [accept]="acepta" [disabled]="!editable"
               (change)="elegirArchivos(entrada)" />
        <label for="t2-evidencia" class="pruebas-dialogo__soltar" (dragover)="permitirSoltar($event)" (drop)="soltar($event)">
          <span class="material-icons pruebas-dialogo__soltar-icono" aria-hidden="true">upload_file</span>
          <span class="pruebas-dialogo__soltar-texto">
            <strong>{{ esEdicion ? "Agregar más evidencia" : "Adjuntar evidencia" }}</strong>
            <span>Arrastre archivos aquí o <span class="pruebas-dialogo__enlace">seleccione un archivo</span></span>
            <small>Reporte de ejecución, capturas o bitácoras · PDF, imágenes, Office, CSV, TXT, LOG o ZIP; sin video</small>
          </span>
        </label>
        <p class="pruebas-dialogo__error" role="alert" *ngIf="avisoArchivos">{{ avisoArchivos }}</p>

        <ul class="pruebas-dialogo__archivos" *ngIf="nuevos.length" aria-label="Evidencia por subir">
          <li *ngFor="let archivo of nuevos; let i = index">
            <span class="pruebas-dialogo__archivo">
              <strong>{{ archivo.name }}</strong>
              <span>{{ lineaArchivo(archivo) }} · se sube al guardar</span>
            </span>
            <button type="button" class="table-page__action-btn" title="Quitar" [attr.aria-label]="'Quitar ' + archivo.name"
                    [disabled]="!editable" (click)="quitarNuevo(i)">
              <span class="material-icons" aria-hidden="true">close</span>
            </button>
          </li>
        </ul>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label aria-hidden="true">Observaciones</mat-label>
          <label class="cdk-visually-hidden" for="t2-observaciones">Observaciones</label>
          <textarea matInput id="t2-observaciones" rows="4" formControlName="observaciones" placeholder="Notas sobre la ejecución"
                    [maxlength]="largoObservaciones"></textarea>
          <mat-hint>Obligatorias si la ejecución quedó bloqueada.</mat-hint>
          <mat-hint align="end">{{ formulario.controls.observaciones.value.length }}/{{ largoObservaciones }}</mat-hint>
          <mat-error>{{ errorDe("observaciones") }}</mat-error>
        </mat-form-field>
      </section>
    </form>

    <div class="pruebas-dialogo__aviso" *ngFor="let aviso of avisos">{{ aviso }}</div>
    <p class="pruebas-dialogo__error" role="alert" *ngIf="mensaje">{{ mensaje }}</p>
  </div>

  <footer mat-dialog-actions class="app-dialog__footer">
    <span class="pruebas-dialogo__obligatorios">* Campos obligatorios</span>
    <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="guardando" (click)="cancelar()">Cancelar</button>
    <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="!editable" [attr.aria-busy]="guardando" (click)="guardar()">
      {{ textoGuardar }}
    </button>
  </footer>
</section>
